module.exports = __webpack_public_path__ + "img/logodark.a2fb76c6.png";